<template>
    <div class="modal-pending">
      <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
        <div v-if="title" class="card-header">
          <h4 class="card-title">{{title}}</h4>
          <p v-if="description" class="category">{{description}}</p>
        </div>
        <div class="card-content">
          <div><i style="font-size: 0.9em">{{message1}}</i></div>
          <br />
          <div><b style="font-size: 1.2em">{{message}}</b></div>
          <br />
          <div v-if="message2">{{message2}}</div>
        </div>
        <div class="card-footer row" style="font-size: 120%">
          <div class="col-md-12">
            <span class="pull-right">
              <button v-if="actionText1" @click="action1()" class="btn btn-fill btn-wd"><i :class="actionIcon1"></i>&nbsp;{{actionText1}}</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    export default {
      name: 'modal-pending',
      data () {
        return {
          loading: false
        }
      },
      props: {
        title: String,
        description: String,
        message1: String,
        message: String,
        message2: String,
        actionText1: {type: String},
        actionText2: {type: String},
        actionIcon1: {type: String},
        actionIcon2: {type: String},
        action1: {type: Function},
        action2: {type: Function}
      }
    }
  </script>
  
  <style>
    .modal-pending {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  </style>